import Dropdown from "../Dropdown";

interface HasExtractionFilters {
  hasExtraction: "" | "yes" | "no";
}

export default function HasExtractionFilter({
  filters,
  handleChange,
}: {
  filters: HasExtractionFilters;
  handleChange: (value: "" | "yes" | "no") => void;
}) {
  return (
    <>
      {/* Has Extraction Filter */}
      <div className="flex flex-col gap-2 justify-between">
        <label
          htmlFor="has-extraction"
          className="block text-sm font-medium text-gray-700 dark:text-zinc-100 mb-1"
        >
          Extraction
        </label>
        <Dropdown
          id="has-extraction"
          value={filters.hasExtraction}
          onChange={(v) => handleChange(v as "" | "yes" | "no")}
          options={[
            { label: "All", value: "" },
            { label: "With extraction", value: "yes" },
            { label: "Without extraction", value: "no" },
          ]}
        />
      </div>
    </>
  );
}
